import * as React from 'react';

import { TooltipWrapper } from '@coursera-web/cds-labs';
import classNames from 'classnames';

import 'css!./__styles__/ToolSection';

type Props = {
  name: string;
  help?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
};

const ToolSection = ({ name, help, children, className }: Props) => {
  return (
    <div className={classNames('rc-ToolSection', className)}>
      <header className="horizontal-box">
        <div className="flex-1">{name}</div>
        {help && (
          <TooltipWrapper
            placement="bottom"
            message={help}
            variant="secondary"
            tooltipClassName="plugin-simulator-tool-section-tooltip"
          >
            <div>?</div>
          </TooltipWrapper>
        )}
      </header>
      <div className="section-body">{children}</div>
    </div>
  );
};

export default ToolSection;
